import React from 'react';
import PropTypes from 'prop-types';
import PageSectionTitle, { PageSectionTextType } from '../PageSectionTitle';
import BundleCard, { BundleCardDataType } from '../BundleCard';
import MaxWidthContainer from '../MaxWidthContainer';
import { isDesktop } from '../../utility/domHelpers';
import DragCarousel from '../DragCarousel';
import CarouselDots from '../CarouselDots';
import Title from '../Title';
import { TextType } from '../Text';

import './BundlesSection.scss';

const className = 'c-BundlesSection';

const BundlesSection = ({ subtitle, title, bundlesData, bundleRef }) => {
  const renderCards = () =>
    bundlesData?.map((item, i) => <BundleCard key={i} {...item} />);

  return (
    <div className={className}>
      <MaxWidthContainer>
        <div ref={bundleRef}></div>
        <Title text={subtitle} />
        <PageSectionTitle title={title} />
        <div className={`${className}__cards-wrapper`}>
          {!isDesktop && (
            <>
              <DragCarousel gap={12}>{renderCards()}</DragCarousel>
              <CarouselDots />
            </>
          )}
          {isDesktop && bundlesData && renderCards()}
        </div>
      </MaxWidthContainer>
    </div>
  );
};

BundlesSection.defaultProps = {
  subtitle: [{ text: 'Bundles' }],
  title: [{ text: 'Course Bundles ' }],
  bundlesData: [],
};

BundlesSection.propTypes = {
  subtitle: TextType,
  title: PageSectionTextType,
  bundlesData: PropTypes.arrayOf(BundleCardDataType),
};

export default BundlesSection;
